import { render } from "./PauseButton.vue?vue&type=template&id=5b69430c&scoped=true"
import script from "./PauseButton.vue?vue&type=script&lang=js"
export * from "./PauseButton.vue?vue&type=script&lang=js"

import "./PauseButton.vue?vue&type=style&index=0&id=5b69430c&scoped=true&lang=scss"

import exportComponent from "/Users/lei.cao/Documents/PRIME_PreProc/ImageQC/SwipesForScience/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b69430c"]])

export default __exports__